import {createRef, Fragment, useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {IgnoredUrl} from "../../../../services/IgonreUrlService";
import {User} from "../../../../services/UsersService";
import {
  IgnoredUrlsState,
  ignoredUrlsState,
  listIgnoredUrls,
  removeIgnoredUrl as removeIgnoredUrlAction,
  insertIgnoredUrl as insertIgnoredUrlAction
} from "./IgnoredUrlsSlice";
import {RequireTier} from "../../../auth/RequireTier";

export interface IgnoreUrlSettingsProps {
  readonly user: User;
}

const IgnoredUrlsTab = (props: IgnoreUrlSettingsProps) => {
  const dispatch = useAppDispatch();
  const state: IgnoredUrlsState = useAppSelector(ignoredUrlsState);

  const removeIgnoredUrl = (ignoredUrlId: number) => {
    dispatch(removeIgnoredUrlAction({userId: props.user.id, ignoredUrlId}));
  };
  const addIgnoredUrl = (type: string, pattern: string) => {
    dispatch(insertIgnoredUrlAction({userId: props.user.id, type, pattern}));
  };
  const addIgnoredUrlInputRef = createRef<HTMLInputElement>();
  const addIgnoredUrlTypeRef = createRef<HTMLSelectElement>();

  useEffect(() => {
    dispatch(listIgnoredUrls({userId: props.user.id}));
  }, [dispatch, props.user]);

  return (
    <Fragment>
      <div className="form-group">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Type</th>
              <th scope="col">Pattern</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {state.ignoredUrls.map((r: IgnoredUrl) => (
              <tr key={r.id}>
                <td>{r.type}</td>
                <td>{r.pattern}</td>
                <td>
                  <RequireTier requiredTier="admin" policy="disable">
                    <button onClick={() => removeIgnoredUrl(r.id)} className="btn btn-primary">
                      <i className="fe fe-trash"></i>
                    </button>
                  </RequireTier>
                </td>
              </tr>
            ))}
            <tr key="new-item">
              <td>
                <select className="form-select" ref={addIgnoredUrlTypeRef} defaultValue="CONTAINS">
                  <option value="CONTAINS">CONTAINS</option>
                  <option value="WILDCARD">WILDCARD</option>
                  <option value="REGEX">REGEX</option>
                  <option value="NOT_CONTAINS">NOT_CONTAINS</option>
                  <option value="WILDCARD_NOT_MATCH">WILDCARD_NOT_MATCH</option>
                  <option value="REGEX_NOT_MATCH">REGEX_NOT_MATCH</option>
                </select>
              </td>
              <td>
                <input className="form-control" ref={addIgnoredUrlInputRef} />
              </td>
              <td>
                <RequireTier requiredTier="admin" policy="disable">
                  <button
                    aria-label="Add ignored URL"
                    onClick={() =>
                      addIgnoredUrl(addIgnoredUrlTypeRef.current?.value || "CONTAINS", addIgnoredUrlInputRef.current?.value || "")
                    }
                    className="btn btn-primary"
                  >
                    <i className="fe fe-plus"></i>
                  </button>
                </RequireTier>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};

export default IgnoredUrlsTab;
